import { useTranslations } from 'next-intl';

import Text from '@commons/components/Text';
import BaseContainer from '@commons/containers/BaseContainer';

/**
 * ContactUsForm ThankYou message component.
 *
 * Renders by default if not overridden by props.
 */

const ContactUsFormThankYou = () => {
  const t = useTranslations('forms.contactUs.thankYou');

  return (
    <BaseContainer paddingRight="xxl">
      <Text as="h2" marginBottom="sm" transform="uppercase">
        {t.rich('title', {
          colored: (label) => (
            <Text as="span" color="aqua-2">
              {label}
            </Text>
          ),
        })}
      </Text>
      <Text marginBottom="md">{t('message')}</Text>
    </BaseContainer>
  );
};

export default ContactUsFormThankYou;
